import {difference, some, split, upperCase} from 'lodash'
import {AuthActions} from 'store/modules/authentication/actions'
import {store} from 'store/store'

export const ContractTypes = {
  Trial: 'trial',
  Customer: 'customer',
  FreePartnerAccount: 'freePartnerAccount',
  MonthlyCreditCardCustomer: 'monthlyCreditCardCustomer',
  AnnualCorporateCustomer: 'annualCorporateCustomer',
}

export const ContractTypeLabel = {
  trial: 'Trial',
  customer: 'Customer',
  freePartnerAccount: 'Free Partner Account',
  monthlyCreditCardCustomer: 'Monthly CreditCard Customer',
  annualCorporateCustomer: 'Annual Corporate Customer',
}

export const Modes = {
  CREATE: 'create',
  UPDATE: 'update'
}

export const DeviceTypes = {
  OFFICE: 'device',
  REMOTE: 'remote'
}

export const DeviceStatus = {
  Online: 'online',
  Offline: 'offline',
  Live: 'live',
  Unknown: 'unknown'
}

export const Roles = {
  superAdmin: 'super-admin',
  distributor: 'distributor',
  reseller: 'reseller',
  business: 'business'
}

export const DefaultRoutes = {
  [Roles.superAdmin]: 'distributor',
  [Roles.distributor]: 'reseller',
  [Roles.reseller]: 'business'
}

export const DefaultRoute = user => {
  const {authentication} = store.getState()
  const _user = user ? user : authentication.user
  const roles = _user.permissions

  if (roles.includes(Roles.superAdmin)) {
    return '/distributor'
  }

  if (roles.includes(Roles.distributor)) {
    return '/reseller'
  }

  if (roles.includes(Roles.reseller)) {
    return '/business'
  }

  if (roles.includes(Roles.business)) {
    return `/business/${_user.adminOf}`
  }
}

export const getInitials = name => {
  const _name = split(upperCase(name), ' ')
  if (_name.length > 1) {
    return `${_name[0].charAt(0)}${_name[1].charAt(0)}`
  } else {
    return _name[0].substring(0, 2)
  }
}

/**
 *
 * @param {Object} permission permissions required
 * @returns Boolean
 */
export const checkPermission = permission => {
  const {
    authentication: {
      user: {permissions}
    }
  } = store.getState()
  return difference(permission, permissions).length > 0
}

export const getSignedInUser = () => {
  const {
    authentication: {user}
  } = store.getState()
  return user
}

export const canAccessAdmin = () => {
  const user = getSignedInUser()
  return user.permissions.includes(Roles.superAdmin) || (user.adminOf && user.entity)
}

export const signOut = () => {
  store.dispatch(AuthActions.logout())
}

/**
 * @description Access verification using weighted roles as
 * super-admin > distributor > reseller > business
 * @param {String} permission Name of role to ACL
 * @returns Boolean
 */
export const hasPermission = permission => {
  const {
    authentication: {
      user: {permissions}
    }
  } = store.getState()
  if (permissions.includes(Roles.superAdmin)) {
    return true
  }

  if (permission === Roles.distributor) {
    return permissions.includes(Roles.distributor)
  }

  if (permission === Roles.reseller) {
    return permissions.includes(Roles.distributor) || permissions.includes(Roles.reseller)
  }

  if (permission === Roles.business) {
    return (
      permissions.includes(Roles.distributor) ||
      permissions.includes(Roles.reseller) ||
      permissions.includes(Roles.business)
    )
  }

  return permissions.includes(permission)
}

export const getDeviceStatus = (status) => {
  if (some(status, s => s.status === DeviceStatus.Live)) {
    return DeviceStatus.Live
  }

  if (some(status, s => s.status === DeviceStatus.Online)) {
    return DeviceStatus.Online
  }

  if (some(status, s => s.status === DeviceStatus.Offline)) {
    return DeviceStatus.Offline
  }

  return DeviceStatus.Unknown
}

export const scrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}
